$(function(){
	var $radio = $(':radio');
	$('#CheckSum').on('click',function(){
		var $checkRadioCount = $('.eat10-radio-list').find('input[type="radio"]:checked').length,
				$radioCount = $('.eat10-radio-list').length;
		$('.eat10-radio-list').each(function() {
			var radioName = $(this).attr('data-radio');
			if($checkRadioCount === $radioCount){
				checkSum();
				$(this).find('.eat10-errorMessage').hide();
				$('.eat10-errorMessage span').hide();
			} else {
				if(!$('input:radio[name="'+radioName+'"]:checked').val()) {
					$('#pointText').html('');
					$(this).find('.eat10-errorMessage').show();
					$('.eat10-errorMessage span').show();
				}
			}
		});
	});
	function checkSum(){
		var total = 0;
		var result = '';
		$radio.filter(':checked').map(function(){
				total += Number(this.value);
		});
		$('#pointText').css('visibility','visible').html(total);
	}
});

(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.2';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

$('.best_articles_slide').slick({
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 3,
	dots: false,
	responsive: [
		{
		  breakpoint: 768,
		  settings: {
		    dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			dots: false,
		  }
		}
  	]
});